export enum WidgetType {
    PRIMENG = "PRIMENG",
    BOOTSTRAP = "BOOTSTRAP",
    ZORRO = "ZORRO"
}